import {REPORT_ALL_GEN0_CLIENTS} from '/enum/records.enum';

export default {
  reportName: REPORT_ALL_GEN0_CLIENTS,
};
